// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"BS-z","categoryName":"CS-z","categoryNameSearchHeader":"DS-z","categoryContent":"ES-z","bottomAligned":"FS-z","image":"GS-z","imageNoBackground":"HS-z"};